export const INTERNAL_SERVER_FAILURE = 'INTERNAL_SERVER_FAILURE';
export const RECOVER_REFRESH_TOKEN = 'RECOVER_REFRESH_TOKEN';
export const FORCE_AUTH_CHECK = 'FORCE_AUTH_CHECK';
